import React from 'react';
import { trackCustom } from '../lib/pixel';
const trackOutbound = (target: string) => trackCustom('OutboundClick', {
  target
});
export function Footer() {
  return <footer className="w-full px-4 sm:px-6 lg:px-8 py-10 text-gray-900 border-t" style={{
    backgroundColor: 'rgb(255,255,255)',
    borderTopColor: 'rgba(14,165,233,0.2)',
    fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif'
  }} data-id="element-193">
      <div className="mx-auto max-w-4xl text-center" data-id="element-194">

        {/* Logo */}
        <div className="mb-3 text-xl font-black tracking-[2.4px]" style={{
        color: '#0284c7'
      }} data-id="element-195">
          🩺 MÉDICO EN PROCESO™
        </div>

        {/* Tagline */}
        <p className="mx-auto max-w-[576px] text-xs leading-[20px] text-gray-600 m-0 mb-3" data-id="element-196">
          El sistema N°1 para estudiantes de Medicina en Argentina que quieren
          organizar su carrera, estudiar con método y aprobar sin improvisar.
        </p>

        <p className="text-xs italic text-gray-500 m-0 mb-6 px-4" data-id="element-197">
          "Porque avanzar en Medicina no debería costarte todas tus noches y
          todos tus fines de semana."
        </p>

        {/* Contact Info */}
        <div className="mb-6 flex flex-col sm:flex-row items-center justify-center gap-3 sm:gap-6 text-xs text-gray-600" data-id="element-198">
          <a href="mailto:soporte@bibliotecaprofesional.com" onClick={() => trackOutbound('email')} className="no-underline text-gray-600 transition-colors" style={{
          ['--hover-color' as any]: '#0284c7'
        }} onMouseEnter={e => e.currentTarget.style.color = '#0284c7'} onMouseLeave={e => e.currentTarget.style.color = ''} data-id="element-199">
            📧 soporte@bibliotecaprofesional.com
          </a>
          <span className="hidden sm:block text-gray-200" data-id="element-200">|</span>
          <span className="text-gray-600" data-id="element-201">
            📲 @biblioteca.profesional
          </span>
          <span className="hidden sm:block text-gray-200" data-id="element-202">|</span>
          <a href="https://www.bibliotecaprofesional.com" target="_blank" rel="noopener noreferrer" onClick={() => trackOutbound('website')} className="no-underline text-gray-600 transition-colors" onMouseEnter={e => e.currentTarget.style.color = '#0284c7'} onMouseLeave={e => e.currentTarget.style.color = ''} data-id="element-203">
            🌐 www.bibliotecaprofesional.com
          </a>
        </div>

        {/* Divider */}
        <div className="mx-auto mb-6 h-px w-24" style={{
        backgroundColor: 'rgba(2,132,199,0.3)'
      }} data-id="element-204" />

        {/* Legal & Copyright */}
        <div className="space-y-1" data-id="element-205">
          <p className="text-[10px] text-gray-500 m-0" data-id="element-206">
            © {new Date().getFullYear()} Biblioteca Profesional™ — Todos los
            derechos reservados.
          </p>
          <p className="text-[10px] text-gray-400 m-0" data-id="element-207">
            Prohibida la reproducción total o parcial y la redistribución sin
            autorización expresa.
          </p>
        </div>
      </div>
    </footer>;
}